import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/apiClient";
import { PageHero } from "../components/Shared";
import { ArrowRight } from "lucide-react";

export default function Actualites() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="actualites-page">
      <PageHero
        label="Actualités"
        title="Le journal de campagne"
        subtitle="Suivez nos déplacements, nos rencontres et nos prises de position sur le terrain."
      />

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {articles.map((a, i) => (
            <article key={a.id} data-testid={`article-card-${i}`} className="group flex flex-col">
              <Link to={`/actualites/${a.slug}`} className="block overflow-hidden rounded-2xl h-56 shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
                <img src={a.thumb || a.image} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </Link>
              <div className="mt-5 flex items-center gap-3">
                <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#12495B]">{a.category}</span>
                <span className="text-xs text-[#4B5563]">
                  {new Date(a.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                </span>
              </div>
              <h3 className="mt-2 font-display text-2xl text-[#12495B] leading-snug">{a.title}</h3>
              <p className="mt-3 text-[#4B5563] leading-relaxed flex-1">{a.excerpt}</p>
              <Link to={`/actualites/${a.slug}`} data-testid={`article-read-${i}`} className="mt-4 text-[#12495B] font-semibold flex items-center gap-2 hover:gap-3 transition-all duration-300">
                Lire l'article <ArrowRight size={17} />
              </Link>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
